App.prototype.handleVariationChanges = function ($this, variations, loaded_checkeds, main_product) {

    let combinations = variations
        .filter(
            variation =>
                (variation.is_active === 1 || (variation.is_active === null && main_product.is_active === 1)) &&
                (variation.is_out_of_stock === false || (variation.is_out_of_stock === null && main_product.is_out_of_stock === false))
        )
        .map((variation) => variation.variationOptions);

    $this
        .closest('.variation')
        .siblings('.variation')
        .find('input[type="radio"]')
        .prop('disabled', false);

    const variation_id = parseInt($this.val());

    const possible_variations = combinations
        .filter((combination) => combination.indexOf(variation_id) !== -1);

    const el_possible_inputs = possible_variations.flat()
        .filter((value, index, array) => array.indexOf(value) === index)
        .map((variation_id) => '[value="'+variation_id+'"]');

    const el_other_variations = $this
        .closest('.variation')
        .siblings('.variation')
        .find('input[type="radio"]:not('+el_possible_inputs.join()+')');

    el_other_variations.prop('disabled', true);

    const checked_variatians =
        $('.variation input:checked')
            .map(
                (k, el) => parseInt($(el).val())
            )
            .toArray()
            .sort();

    variations
        .filter((combination) => JSON.stringify(combination.variationOptions.sort()) === JSON.stringify(checked_variatians))
        .forEach((item) => {

            if (loaded_checkeds === 0){

                if ($('.modal.show').length || $('.mfp-wrap.mfp-product.mfp-ready').length){

                    return App.prototype.showProduct(item.unique_id, null);

                }

                return location.href = item.url;

            }else{

                loaded_checkeds--;

            }

        });

    return loaded_checkeds;

};

App.prototype.checkVariationStatus = function (variations, main_product){
    const el_variations = $(document).find(".variation input[type='radio']");

    let loaded_checkeds = el_variations.filter((k, el) => $(el).is(':checked')).length

    $(document).on('change', '.variation input[type="radio"]', function () {
        loaded_checkeds = App.prototype.handleVariationChanges($(this), variations, loaded_checkeds, main_product);
    });

    el_variations
        .filter((k, el) => $(el).is(':checked'))
        .each((k, el) => {

            $(el).trigger('change');

        });

    // Above code handles combinations. If variation tree has 1 level, handle disabling.
    App.prototype.checkSingleLevelVariationStatus(variations);
}

if (typeof variations !== 'undefined'){

    App.prototype.checkVariationStatus(variations, main_product);

}
